import { solidstate } from ":setup/qstate";
import { Show } from "solid-js";
import Form from "./components/form";
import Success from "./components/success";
import type { UserDetails } from "./_model";
import DefaultLayout from "../SHARED/layouts/default-layout";
import * as validate from "./apis/validate";

export default function ConfirmAccount() {
  const $user_details = solidstate.create(null as UserDetails);
  const $done = solidstate.create(false);
  return (
    <DefaultLayout
      //
      api={validate.get}
      onValid={(details) => {
        $user_details.set(details);
      }}
    >
      <Show when={!$done.value} fallback={<Success />}>
        {$user_details.value.attendance_status === true ? (
          <p class="text-20px text-center my-auto">you have already confirmed your attendance.</p>
        ) : (
          <Form
            data={{ email: $user_details.value.email }}
            onDone={() => {
              $done.set(true);
            }}
          />
        )}
      </Show>
    </DefaultLayout>
  );
}
